import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Proposal } from 'app/entities/proposal';
import { formatBRL } from 'app/helpers/money';

export type ProposalConfirmDateAction = 'faturar' | 'pagar';

const TEXTS: Record<ProposalConfirmDateAction, { title: string; field: string; hint: string; button: string; icon: string }> = {
    faturar: {
        title: 'Faturar orçamento',
        field: 'Data de faturamento',
        hint: 'Todas as parcelas em aberto ficam faturadas nesta data.',
        button: 'Confirmar faturamento',
        icon: 'receipt_long',
    },
    pagar: {
        title: 'Registrar pagamento do orçamento',
        field: 'Data do pagamento',
        hint: 'Todas as parcelas ficam pagas nesta data.',
        button: 'Confirmar pagamento',
        icon: 'paid',
    },
};

/**
 * ORCA-1966: faturar e registrar pagamento pela lista. Pede só a confirmação da data
 * (hoje por padrão), sem abrir o detalhe do orçamento.
 */
@Component({
    selector: 'app-proposal-confirm-date-dialog',
    templateUrl: './proposal-confirm-date-dialog.component.html',
    styleUrls: ['./proposal-confirm-date-dialog.component.scss'],
})
export class ProposalConfirmDateDialogComponent {
    date: Date | null = new Date();
    readonly today = new Date();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { action: ProposalConfirmDateAction; proposal: Proposal },
        private dialogRef: MatDialogRef<ProposalConfirmDateDialogComponent, { date: Date }>,
    ) { }

    get texts() {
        return TEXTS[this.data.action];
    }

    get proposal(): Proposal {
        return this.data.proposal;
    }

    get value(): string {
        return formatBRL(this.proposal?.totalLiquid);
    }

    confirm(): void {
        if (this.date) {
            this.dialogRef.close({ date: this.date });
        }
    }
}
